<div class="bg-white shadow-md w-full fixed z-1000 flex justify-between items-center px-4 sm:px-6 h-14 sm:h-16">
  <div class="flex flex-row items-center gap-4">
    <a routerLink="/" class="hidden sm:flex items-center">
      <img
        alt="Artesp"
        src="Logotipo.svg"
        width="150"
        height="23"
      />
    </a>

    <div class="vertical-hr hidden sm:block"></div>

    <a routerLink="/" class="flex items-center">
      <img
        alt="Sisdemanda"
        src="logo.png"
        width="140"
        height="23"
      />
    </a>
  </div>

  @if (authService.isAuthenticated()) {
    <div class="flex flex-row gap-4 sm:gap-6 items-center">
      <app-menu-profile
        [name]="nomeUsuario || ''"
      ></app-menu-profile>
    </div>
  }
</div>
